<template>
    <v-card class="tw-shadow-none tw-bg-transparent tw-border-none tw-p-0 tw-py-5 post">
        <div class="tw-flex tw-items-center">
            <v-img alt="user" :aspect-ratio="1/1" max-height="48" max-width="48" class="tw-border tw-border-solid tw-border-white tw-border-opacity-10 tw-rounded-full" :src="pageOptions.logo ? pageOptions.logo : (artist.post_image ? artist.post_image : spotifyArtist.images[2].url)" />
            <div class="tw-flex tw-flex-col tw-text-white tw-font-sans tw-pl-2">
                <h4 class="tw-m-0 tw-p-0 tw-text-base tw-font-bold">{{artist.artista_nome}}</h4>
                <div class="tw-flex tw-items-center tw-mt-1">
                    <p class="tw-m-0 tw-p-0 tw-text-xs tw-opacity-40 tw-leading-none">
                        {{createdAt}}
                    </p>
                    <p class="tw-m-0 tw-p-0 tw-text-xs tw-opacity-40 tw-leading-none" v-if="artista_id == artist.artista_id">
                        <span class="tw-mx-1">•</span>
                        <i class="fas" :class="{'fa-globe-americas': post.visibility == 'public', 'fa-key': post.visibility == 'subscriber', 'fa-user-check': post.visibility == 'follower', 'fa-shopping-bag': post.visibility == 'buyer'}"></i>
                        {{ post.visibility == 'public' ? 'Público' : post.visibility == 'subscriber' ? 'Assinantes' : post.visibility == 'follower' ? 'Seguidores' : 'Compradores' }}
                    </p>
                </div>
            </div>
            <v-spacer></v-spacer>
            <v-menu bottom left v-if="artista_id == artist.artista_id && editing == false">
                <template v-slot:activator="{ on, attrs }">
                    <v-btn color="white" small icon v-bind="attrs" v-on="on"  class="focus:tw-outline-none">
                        <v-icon>mdi-dots-horizontal</v-icon>
                    </v-btn>
                </template>
                <v-list dense>
                    <v-list-item link @click="editing = true">
                        <v-icon class="tw-text-sm tw-mr-2">far fa-edit</v-icon>
                        <v-list-item-title>Editar</v-list-item-title>
                    </v-list-item>
                    <v-list-item link @click="dialog = true">
                        <v-icon class="tw-text-sm tw-mr-2 tw-text-red-600">far fa-trash-alt</v-icon>
                        <v-list-item-title class="tw-text-red-600">Excluir</v-list-item-title>
                    </v-list-item>
                </v-list>
            </v-menu>
            <v-dialog v-model="dialog" max-width="290">
                <v-card>
                    <v-card-title class="text-h5">
                        Excluir publicação?
                    </v-card-title>
                    <v-card-text class="tw-opacity-50">
                        Ao excluir todas as informações incluidas na publicação também serão removidas.
                    </v-card-text>
                    <v-divider></v-divider>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="white" class="focus:tw-outline-none" text @click="dialog = false">
                            Cancelar
                        </v-btn>
                        <v-btn color="red darken-1" @click="deletePost()" class="focus:tw-outline-none" text>
                            Excluir
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </div>
        <div class="tw-text-white tw-font-sans tw-mt-4">
            <p class="tw-text-sm tw-whitespace-pre-line" :id="'description'+post.id" v-text="post.description" v-if="(editing == false && (post.visibility !== 'public' ? post.medias : true)) || editing == false && artista_id == artist.artista_id"></p>
            <div v-if="editing == true" class="tw-mb-5">
                <div class="tw-flex tw-items-center tw-mb-3">
                    <v-menu v-model="menu" :close-on-content-click="true" transition="slide-x-transition">
                        <template v-slot:activator="{ on, attrs }">
                            <a id="visibility" v-bind="attrs" v-on="on" v-ripple class="tw-bg-white tw-bg-opacity-10 tw-font-sans tw-text-white tw-rounded">
                                <i class="fas tw-mr-1" :class="{'fa-globe-americas': form.visibility == 'public', 'fa-key': form.visibility == 'subscriber', 'fa-user-check': form.visibility == 'follower', 'fa-shopping-bag': form.visibility == 'buyer'}"></i>
                                {{ form.visibility == 'public' ? 'Público' : form.visibility == 'subscriber' ? 'Assinantes' : form.visibility == 'follower' ? 'Seguidores' : 'Compradores' }}
                            </a>
                        </template>
                        <v-card class="tw-px-2">
                            <v-radio-group v-model="form.visibility">
                                <div class="tw-flex tw-items-center tw-rounded tw-bg-gray-800 tw-bg-opacity-10 tw-p-2 tw-w-full tw-cursor-pointer tw-mb-2" v-ripple @click="$refs.radioPublic.$el.click()">
                                    <div class="tw-w-12 tw-h-12 tw-bg-opacity-10 tw-bg-black tw-text-white tw-text-opacity-40 tw-text-lg tw-flex tw-relative tw-items-center tw-justify-center tw-rounded-full tw-flex-shrink-0">
                                        <i class="fas fa-globe-americas tw-absolute"></i>
                                    </div>
                                    <div class="tw-flex tw-flex-col tw-font-sans tw-text-white tw-ml-3 tw-flex-shrink-0">
                                        <p class="tw-m-0 tw-text-base">Público</p>
                                        <p class="tw-m-0 tw-text-xs tw-opacity-40">Qualquer pessoa que acessar</p>
                                    </div>
                                    <div class="tw-flex tw-flex-col tw-font-sans tw-text-white tw-ml-3 tw-w-full tw-items-end">
                                        <v-radio color="white" ref="radioPublic" value="public"></v-radio>
                                    </div>
                                </div>
                                <div class="tw-flex tw-items-center tw-rounded tw-bg-gray-800 tw-bg-opacity-10 tw-p-2 tw-w-full tw-cursor-pointer tw-mb-2" v-ripple @click="$refs.radioFollower.$el.click()">
                                    <div class="tw-w-12 tw-h-12 tw-bg-opacity-10 tw-bg-black tw-text-white tw-text-opacity-40 tw-text-lg tw-flex tw-relative tw-items-center tw-justify-center tw-rounded-full tw-flex-shrink-0">
                                        <i class="fas fa-user-check tw-absolute"></i>
                                    </div>
                                    <div class="tw-flex tw-flex-col tw-font-sans tw-text-white tw-ml-3 tw-flex-shrink-0">
                                        <p class="tw-m-0 tw-text-base">Seguidores</p>
                                        <p class="tw-m-0 tw-text-xs tw-opacity-40">Qualquer pessoa que for seu seguidor</p>
                                    </div>
                                    <div class="tw-flex tw-flex-col tw-font-sans tw-text-white tw-ml-3 tw-w-full tw-items-end">
                                        <v-radio color="white" ref="radioFollower" value="follower"></v-radio>
                                    </div>
                                </div>
                                <div class="tw-flex tw-items-center tw-rounded tw-bg-gray-800 tw-bg-opacity-10 tw-p-2 tw-w-full tw-cursor-pointer tw-mb-2" v-if="options.subscriber" v-ripple @click="$refs.radioSubscriber.$el.click()">
                                    <div class="tw-w-12 tw-h-12 tw-bg-opacity-10 tw-bg-black tw-text-white tw-text-opacity-40 tw-text-lg tw-flex tw-relative tw-items-center tw-justify-center tw-rounded-full tw-flex-shrink-0">
                                        <i class="fas fa-key tw-absolute"></i>
                                    </div>
                                    <div class="tw-flex tw-flex-col tw-font-sans tw-text-white tw-ml-3 tw-flex-shrink-0">
                                        <p class="tw-m-0 tw-text-base">Assinantes</p>
                                        <p class="tw-m-0 tw-text-xs tw-opacity-40">Qualquer pessoa que for seu assinante</p>
                                    </div>
                                    <div class="tw-flex tw-flex-col tw-font-sans tw-text-white tw-ml-3 tw-w-full tw-items-end">
                                        <v-radio color="white" ref="radioSubscriber" value="subscriber"></v-radio>
                                    </div>
                                </div>
                                <!-- <div class="tw-flex tw-items-center tw-rounded tw-bg-gray-800 tw-bg-opacity-10 tw-p-2 tw-w-full tw-cursor-pointer" v-ripple @click="$refs.radioBuyer.$el.click()">
                                    <div class="tw-w-12 tw-h-12 tw-bg-opacity-10 tw-bg-black tw-text-white tw-text-opacity-40 tw-text-lg tw-flex tw-relative tw-items-center tw-justify-center tw-rounded-full tw-flex-shrink-0">
                                        <i class="fas fa-shopping-bag tw-absolute"></i>
                                    </div>
                                    <div class="tw-flex tw-flex-col tw-font-sans tw-text-white tw-ml-3 tw-flex-shrink-0">
                                        <p class="tw-m-0 tw-text-base">Compradores</p>
                                        <p class="tw-m-0 tw-text-xs tw-opacity-40">Qualquer pessoa que comprar a publicação</p>
                                    </div>
                                    <div class="tw-flex tw-flex-col tw-font-sans tw-text-white tw-ml-3 tw-w-full tw-items-end">
                                        <v-radio color="white" ref="radioBuyer" value="buyer"></v-radio>
                                    </div>
                                </div> -->
                            </v-radio-group>
                        </v-card>
                    </v-menu>
                </div>
                <v-textarea v-model="form.description" filled auto-grow color="white" class="tw-text-sm" hide-details></v-textarea>
                <div class="tw-flex tw-items-center tw-justify-end tw-mt-4">
                    <v-btn color="white" class="focus:tw-outline-none tw-mr-2" text @click="cancelEdit()">
                        Cancelar
                    </v-btn>
                    <v-btn light @click="editPost()" class="focus:tw-outline-none">
                        Finalizar
                    </v-btn>
                </div>
            </div>
            <div class="tw-flex tw-flex-wrap tw--mx-2 tw--mt-2" v-if="post.medias ? postVisible : false">
                <div class="tw-w-4/12 tw-px-1 tw-py-2" v-for="(media, index) in !single ? post.medias.slice(0,5) : post.medias" :key="index">
                    <post-media :media="media" :artist="artist" :post="post" :subscriber="subscriber"></post-media>
                </div>
                <div class="tw-w-4/12 tw-px-1 tw-py-2" v-if="!single ? post.medias.length > 5 : false">
                    <inertia-link :href="tenant ? `/backstage/${post.id}` : `/artist/${artist.artista_url}/backstage/${post.id}`" v-ripple class="tw-w-full tw-h-full tw-flex tw-items-center tw-justify-center tw-text-black">
                        <v-img height="auto" width="100%" max-height="100%" :aspect-ratio="1/1" class="tw-rounded tw-border tw-border-solid tw-border-white tw-border-opacity-10 tw-flex tw-items-center tw-justify-center">
                            <div class="tw-w-full tw-text-center tw-m-auto">
                                <i class="fas fa-photo-video tw-text-white tw-text-xl"></i>
                                <h3 class="tw-w-full tw-font-sans tw-text-xs md:tw-text-sm tw-tracking-widest tw-font-bold tw-mt-1">VER ÁLBUM</h3>
                            </div>
                        </v-img>
                    </inertia-link>
                </div>
            </div>
            <div class="tw-flex tw-flex-col tw-items-center tw-justify-center tw-mt-2 tw-w-full tw-py-8 tw-border tw-border-white tw-border-opacity-10 tw-rounded" v-if="postVisible == false">
                <i class="fas fa-lock tw-text-white tw-text-2xl tw-opacity-30 tw-mb-2"></i>
                <p class="tw-font-sans tw-text-sm tw-text-white tw-opacity-40 tw-mb-2 tw-p-0">Esse conteúdo tem acesso restrito</p>
                <v-btn href="#" @click="Object.keys(currentUser).length ? follow({currentUser: currentUser, artist: artist}) : activateLoginPopup()" v-if="!following && post.visibility == 'follower'" class="dialogActivator waves-effect tw-rounded-full tw-px-5 tw-py-2 tw-bg-white tw-text-black tw-font-sans tw-text-xs tw-font-black tw-uppercase tw-tracking-wide tw-leading-none"><i class="fas fa-plus tw-mr-1"></i><span class="tw-leading-none">Seguir Para desbloquear</span></v-btn>
                <v-btn v-if="!subscriber && post.visibility == 'subscriber'" @click="activateSubscribePopup()" class="waves-effect tw-rounded-full tw-px-5 tw-py-2 tw-bg-white tw-text-white tw-font-sans tw-text-xs tw-font-bold tw-uppercase tw-tracking-wide tw-leading-none tw-from-purple-400 tw-to-purple-600 tw-bg-gradient-to-b tw-shadow-none"><i class="fas fa-key tw-mr-1"></i><span class="tw-leading-none">Assinar Para desbloquear</span></v-btn>
            </div>
            <div class="tw-flex tw-items-center tw-font-sans tw-text-white tw-text-xs tw-mt-2" v-if="editing == false">
                <span class="tw-font-bold tw-mx-1">{{likeCount === 0 ? "" : likeCount}}</span>
                <svg v-if="likeCount != 0" version="1.1" id="Layer_1" class="tw-w-3" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 11.2 12.9" style="enable-background:new 0 0 11.2 12.9;" xml:space="preserve">
                    <path :class="{'tw-stroke-1 tw-stroke-current': !liked, 'tw-stroke-0 tw-fill-current': liked}" class="st0" d="M7.3,12.3c0.6,0.3,3.1-1.8,3.2-4.2c0.1-1-0.3-1.9-0.5-2.6C9.5,4.2,8.8,3.2,8.3,2.6C8,3.2,7.6,3.8,7.3,4.4
                        C7.2,3.9,6.9,3.2,6.4,2.5c-0.7-1-1.7-1.5-2.1-1.7c-0.3,1-0.4,2-1.4,3.4C2.1,5.4,1.3,6,0.8,7.3C0.5,8,0.6,9.9,1.1,10.6
                        c1.1,1.5,2.6,1.7,2.7,1.7C3.7,11.9,3.3,10.6,4,9.1c0.4-1,1.1-1.6,1.5-1.8c0.5,0.4,1.1,1,1.6,2C7.8,10.8,7.3,12.3,7.3,12.3z"/>
                </svg>
                <v-btn @click="getCommentShow" small plain>comentários</v-btn>
            </div>
            <div v-if="commentShow" class="tw-font-sans tw-text-white tw-text-xs tw-mt-2">
                <div v-for="commentPost in this.commentPosts" :key="commentPost.id">
                    <div class="tw-flex tw-py-1">
                        <img class="tw-rounded-full tw-w-8 tw-h-8 tw-mx-2" :src="commentPost.user.avatar" alt="avatar">
                        <v-card
                            elevation="2"
                            class="tw-p-3 tw-rounded-md tw-flex tw-flex-col tw-w-full"
                        >
                            <div class="tw-flex tw-justify-between">
                                <label><strong>{{commentPost.user.name}}</strong></label>
                                <v-menu offset-y v-if="commentPost.user.email == currentUserEmail">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn
                                        dark
                                        v-bind="attrs"
                                        v-on="on"
                                        plain
                                        text
                                        >
                                        ...
                                        </v-btn>
                                    </template>
                                    <v-list>
                                        <v-list-item>
                                            <v-list-item-title>
                                                <div class="tw-mt-2 tw-flex tw-flex-col">
                                                    <v-btn small plain @click="editOnClickComment(commentPost)">Editar<v-icon class="tw-mx-2 tw-text-xs">far fa-edit</v-icon></v-btn>
                                                    <v-btn small plain @click="removeComment(commentPost.id)">Excluir<v-icon class="tw-mx-2 tw-text-xs">fa fa-trash</v-icon></v-btn>
                                                </div>
                                            </v-list-item-title>
                                        </v-list-item>
                                    </v-list>
                                </v-menu>
                            </div>
                            <span>{{commentPost.comment}}</span>
                        </v-card>
                    </div>
                </div>
            </div>
            <div class="tw-flex tw-items-center tw-my-2 tw-w-3/4" v-if="editing == false">
                <v-btn class="tw-text-white tw-p-4 mx-1" @click="toggleLike()" small>
                    <svg version="1.1" id="Layer_1" class="tw-w-4" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 11.2 12.9" style="enable-background:new 0 0 11.2 12.9;" xml:space="preserve">
                        <path :class="{'tw-stroke-1 tw-stroke-current': !liked, 'tw-stroke-0 tw-fill-current': liked}" class="st0" d="M7.3,12.3c0.6,0.3,3.1-1.8,3.2-4.2c0.1-1-0.3-1.9-0.5-2.6C9.5,4.2,8.8,3.2,8.3,2.6C8,3.2,7.6,3.8,7.3,4.4
                            C7.2,3.9,6.9,3.2,6.4,2.5c-0.7-1-1.7-1.5-2.1-1.7c-0.3,1-0.4,2-1.4,3.4C2.1,5.4,1.3,6,0.8,7.3C0.5,8,0.6,9.9,1.1,10.6
                            c1.1,1.5,2.6,1.7,2.7,1.7C3.7,11.9,3.3,10.6,4,9.1c0.4-1,1.1-1.6,1.5-1.8c0.5,0.4,1.1,1,1.6,2C7.8,10.8,7.3,12.3,7.3,12.3z"/>
                    </svg>
                    <label class="tw-mx-1 tw-font-sans tw-text-xs tw-cursor-pointer">Fire</label>
                </v-btn>
                <v-btn class="tw-text-white tw-p-4 mx-1" @click="comment()" small>
                    <v-icon small>far fa-comment</v-icon>
                    <label class="tw-mx-1 tw-font-sans tw-text-xs tw-cursor-pointer">Comentar</label>
                </v-btn>
            </div>
            <div v-if="commentModal" class="tw-mt-8 tw-pb-2 tw-flex tw-items-center tw-justify-center">
                <img class="tw-rounded-full tw-w-10 tw-h-10" :src="this.currentUser.avatar" alt="user">
                <div class="tw-flex tw-w-full">
                    <v-textarea class="tw-text-white tw-mx-2 tw--mt-3 tw-text-xs tw-font-sans tw-rounded-lg" v-model="commentForm.comment" no-resize hide-details color="white" placeholder="Comente aqui..." filled name="commentForm.comment"></v-textarea>
                    <v-btn :disabled="!commentForm.comment.length" @click="sendComment()">Enviar</v-btn>
                </div>
            </div>
            <!-- • <span class="tw-font-bold">22</span> comentários</p> -->
        </div>
    </v-card>
</template>

<script>
import PostMedia from './media';
import EventBus from '@/eventbus';
import Autolinker from 'autolinker';
import {mapState, mapActions} from 'vuex';
import moment from 'moment';
window.moment = global.moment = moment;
moment.locale('pt-br');
export default {
    components: {PostMedia},
    props: ['post', 'artist', 'spotifyArtist', 'single', 'subscriber', 'options', 'pageOptions'],
    data(){
        return{
            liked: false,
            likeCount: 0,
            editing: false,
            dialog: false,
            menu: false,
            commentModal: false,
            commentPosts : '',
            commentShow: false,

            form: {
                description: this.post.description,
                visibility: this.post.visibility
            },

            commentForm: {
                comment: '',
            },

            currentUserEmail: ''
        }
    },
    computed: {
        ...mapState('followstatus', ['following']),
        postVisible(){
            if(this.artista_id == this.artist.artista_id){
                return true;
            }
            switch (this.post.visibility) {
                case 'public':
                    return true;
                    break;

                case 'follower':
                    return this.following;
                    break;

                case 'subscriber':
                    return this.subscriber;
                    break;

                case 'buyer':
                    return false;
                    break;

                default:
                    return true;
                    break;
            }
        },
        createdAt(){
            return moment(this.post.created_at).from(new Date())
        },
    },
    methods: {
        ...mapActions('followstatus', ['follow']),
        toggleLike(){
            if(Object.keys(this.currentUser).length){
                axios.post('/api/like', {
                    user_id: this.currentUser.id,
                    post_id: this.post.id,
                }).then(res => {
                    this.liked = res.data.liked;
                    this.likeCount = res.data.likeCount;
                });
                return
            }
            $('.dialogActivator')[0].click();
        },
        async getComment(){
            const commentPost = (await axios.get(`${process.env.MIX_DASHBOARD_API_BASE}/comments/post/${this.post.id}`)).data
            this.commentPosts = commentPost.filter(commentPost => commentPost.is_active)
        },
        getCommentShow() {
            if(Object.keys(this.currentUser).length){
                this.commentShow = !this.commentShow
                this.currentUserEmail = this.currentUser.email
                return
            }
            $('.dialogActivator')[0].click();
        },
        comment(){
            if(Object.keys(this.currentUser).length){
                this.commentModal = true
                return
            }
            $('.dialogActivator')[0].click();
        },
        editOnClickComment(body){
            this.commentModal = true
            this.commentForm.comment = body.comment
            this.commentPosts.id = body.id
        },
        editComment(){
            axios({
                method: 'patch',
                url: `${process.env.MIX_DASHBOARD_API_BASE}/comments/${this.commentPosts.id}`,
                data: {
                    comment: this.commentForm.comment
                }
            })
            .then(res => {
                this.commentForm.comment = ''
                this.getComment()
            });
        },
        removeComment(id){
            axios({
                method: 'patch',
                url: `${process.env.MIX_DASHBOARD_API_BASE}/comments/disable/${id}`,
            })
            .then(res => {
                this.getComment()
            });
        },
        sendComment(){
            if(this.commentPosts.id) {
                this.editComment()
                return
            }
            axios.post('${process.env.MIX_DASHBOARD_API_BASE}/comments/', {
                comment: this.commentForm.comment,
                post_id: this.post.id,
                user: {
                    name: this.currentUser.name,
                    email: this.currentUser.email,
                    avatar: this.currentUser.avatar,
                }
            })
            .then(res => {
                this.commentForm.comment = ''
                this.getComment()
                this.commentShow = true
            }
            );
        },
        getLike(){
            if(Object.keys(this.currentUser).length){
                axios.get('/api/like', {
                    params: {
                        user_id: this.currentUser.id,
                        post_id: this.post.id,
                    }
                }).then(res => {
                    this.liked = res.data.liked;
                });
            }
        },
        deletePost(){
            axios.delete('/api/posts/'+this.post.id)
            .then(e => {
                this.dialog = false;
                EventBus.$emit('reload-posts');
                this.$page.message = 'Publicação excluída!'
            });
        },
        editPost(){
            axios.put('/api/posts/'+this.post.id, {
                description: this.form.description,
                visibility: this.form.visibility,
            }).then(e => {
                this.menu = false;
                EventBus.$emit('reload-posts');
                this.$page.message = 'Modificações publicadas!'
            })
        },
        cancelEdit(){
            this.form.description = this.post.description;
            this.form.visibility = this.post.visibility;
            this.editing = false;
            this.menu = false;
            setTimeout(() => {
                var description = document.getElementById('description'+this.post.id);
                description.innerHTML = Autolinker.link(description.innerHTML, {
                    phone: false,
                    truncate: {
                        length: 32, location: 'end'
                    }
                });
            }, 100);
        },
        activateLoginPopup(){
            EventBus.$emit('activatePopup');
        },
        activateSubscribePopup(){
            EventBus.$emit('activateSubscribePopup');
        }
    },
    async mounted(){
        await this.getComment()
        this.likeCount = !this.post.like_counter ? 0 : this.post.like_counter.count
        this.getLike();
        if(document.getElementById('description'+this.post.id)){
            var description = document.getElementById('description'+this.post.id);
            description.innerHTML = Autolinker.link(description.innerHTML, {
                phone: false,
                truncate: {
                    length: 32, location: 'end'
                }
            });
        }
    },
    watch: {
        currentUser(newVal, oldVal){
            if(Object.keys(newVal).length){
                this.getLike();
            }
        }
    }
}
</script>

<style>
.v-input__control {
    height: 10px;
    max-height: 30px;
}
</style>
